export default "ORI - Gestión de Templos de Umbanda";
